// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 993) return "static/css/993.f5a8e1dd46a02b7f5fcf.lib.css";
	if (chunkId === 579) return "static/css/579.20c65a83577d296348dd.css";
	// return url for filenames based on template
	return undefined;
};